import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
import vuetify from '@/plugins/vuetify'

const PATTERN = {
  DATE: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[0-9]|[0-9]\d)?\d{2})$/,
  SPECIAL_CHARACTER: /[!@#$%^&*(),.?":{}|<>]/g,
  // eslint-disable-next-line
  PHONE: /^[+]?[(]?[+]?[0-9]{1,3}[-\s.]?[(]?[0-9]{1,4}[)]?[)]?[-\s.]?[0-9]{2,4}[-\s.]?[0-9]{3,5}$/im,
  EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // eslint-disable-next-line
  URL: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
  // eslint-disable-next-line
  DOMAIN: /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])$/gm,
}

const inputRules = {
  date: val => PATTERN.DATE.test(val) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.DATE'),
  required: value => !!value || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.REQUIRED'),
  notSpace: value => value.replace(' ') === value || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NO_WHITESPACES'),
  notSpecialCharacters: value => !value.match(PATTERN.SPECIAL_CHARACTER) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NO_SPECIAL_CHARACTER'),
  percentage: value => (Number(value) > 0 && Number(value) < 100) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.PERCENTAGE'),
  atLeastOne: value => value.length > 0 || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.AT_LEAST_ONE'),
  maxLength: length => (value = '') => {
    if (!value) value = ''
    return value.length <= length || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.MAX_LENGTH', length)
  },
  minLength: length => (value = '') => {
    if (!value) value = ''
    return value.length >= length || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.MIN_LENGTH', length)
  },
  phone: value => value.match(PATTERN.PHONE) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.PHONE'),
  email: value => PATTERN.EMAIL.test(value) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.EMAIL'),
  url: value => {
    if (!value || value.length === 0) return true
    return PATTERN.URL.test(value) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.URL')
  },
  number: value => {
    return !isNaN(value) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NUMBER')
  },
  validPrice: value => {
    return Number(value) >= 10000 || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.VALID_PRICE')
  },
  greaterEqual: number => value => {
    return Number(value) >= Number(number) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NUMBER_GREATER_EQUAL', number)
  },
  greaterThan: number => value => {
    return Number(value) > Number(number) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NUMBER_GREATER_THAN', number)
  },
  lessThan: number => value => {
    return Number(value) < Number(number) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NUMBER_LESS_THAN', number)
  },
  clamp: (min, max) => value => {
    min = Number(min)
    max = Number(max)
    value = Number(value)
    return (value >= min && value <= max) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.NUMBER_CLAMP', min, max)
  },
  dateGreaterThan: (date, format = 'hh:mm DD/MM/YYYY') => value => {
    return new Date(value).getTime() > new Date(date).getTime() || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.DATE_GREATER_THAN', dayjs(date).format(format))
  },
  domain: value => PATTERN.DOMAIN.test(value) || vuetify.framework.lang.translator('$vuetify.INPUT.RULES.DOMAIN')
}

export default inputRules